import { defaultToolResource, useToolActions } from '../../../../resource/resources/artifacts/tool/toolResource';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import { OpenModal } from '../../../../../../react-commons/utils/modals/openModal';
import {
    defaultProcessAreaToolAssociationResource,
    useProcessAreaToolAssociationActions,
} from '../../../../resource/resources/artifacts/process_area/processAreaToolAssociationResource';
import { StackedCardsComponent } from '../../../reusable-components/StackedCardsComponent';
import { useDeleteResourceDialogFunction } from '../../../reusable-components/dialogs/UseDeleteResourceDialogFunction';
import React from 'react';
import { ToolEditDialog } from '../../project/reusable-elements/tool/ToolEditDialog';
import { useNestedDialogFunction } from '../../../../../../react-commons/dialog-provider/UseNestedDialogFunction';

export const StackedToolsView = ({isAdmin, processAreaId, versionId, link}: {
    isAdmin: boolean,
    processAreaId: string | undefined,
    versionId: string | undefined,
    link: string | undefined
}) => {

    const nestedDialog = useNestedDialogFunction();
    const deleteResourceDialogFunction = useDeleteResourceDialogFunction();

    const toolAssociationActions = useProcessAreaToolAssociationActions()
    const toolActions = useToolActions()
    const toolAssociationsQuery = toolAssociationActions.useGetAllResources(processAreaId)
    const toolsQuery = toolActions.useGetAllResources(versionId);

    const deleteToolAssociation = toolAssociationActions.useDeleteResource();
    const addToolAssociation = toolAssociationActions.useAddResource();
    const addTool = toolActions.useAddResource();
    const addAssociation = () => OpenModal.SelectionOrCreateModal(
        "Select or Create a Tool",
        toolsQuery.data?.filter(tool =>
            !(toolAssociationsQuery.data
                ?.some(association => association.tool === tool.objectId)))
            .map(tool => ({label: tool.name, value: tool.objectId})) ?? [],
        true,
        null,
        async (value) => {
            if (value && processAreaId) {
                await addToolAssociation.mutateAsync({
                    resource: {
                        ...defaultProcessAreaToolAssociationResource,
                        tool: value
                    },
                    parentId: processAreaId
                })
            }
        },
        async (value, multiLineValue) => {
            if (value && processAreaId && versionId) {
                await addTool.mutateAsync({
                        resource: {
                            ...defaultToolResource,
                            name: value,
                            description: multiLineValue ?? ""
                        },
                        parentId: versionId
                    },
                    {
                        onSuccess: (result) => {
                            const toolObjectId = result?.content?.objectId
                            if (toolObjectId) {
                                addToolAssociation.mutateAsync({
                                    resource: {
                                        ...defaultProcessAreaToolAssociationResource,
                                        tool: toolObjectId
                                    },
                                    parentId: processAreaId
                                })
                            }
                        },
                    }
                )
            }
        },
        undefined,
        "Name",
        true,
        "Description",
        800
    )

    const onDelete = (id: string) => {
        deleteResourceDialogFunction.deleteResource(
            id, null, ResourceType.PROCESS_AREA_TOOL_ASSOCIATION, deleteToolAssociation
        )
    }

    const onEdit = (id: string) => {
        const association = toolAssociationsQuery.data?.find(value => value.id === id)
        if (association) {
            nestedDialog.showNestedDialog(
                <ToolEditDialog
                    onClose={nestedDialog.closeNestedDialog}
                    objectId={association.tool}
                    versionedInId={versionId ?? ""}
                />
            );
        }
    }

    return (
        <StackedCardsComponent
            title={"Tools"}
            data={toolAssociationsQuery.data?.map(value => ({
                id: value.id,
                text: toolsQuery.data?.find(resource => resource.objectId === value.tool)?.name ?? "",
                description: toolsQuery.data?.find(resource => resource.objectId === value.tool)?.description ?? "",
                img: null
            })) ?? []}
            onAdd={isAdmin ? addAssociation : undefined}
            onDelete={isAdmin ? onDelete : undefined}
            onEdit={isAdmin ? onEdit : undefined}
            link={link}
            section={"tools"}
        />
    );
};